export const generateMarketKey = (group, market) => {
    const base = (market.base || market.base === 0) ? market.base : '';
    const type = market.market_type || '';
    const colCount = market.col_count || '';

    return [
        group,
        type,
        market.display_key,
        base,
        colCount
    ].join('_');
}

export const getMarketDataByKey = key => {
    const [group, market_type, display_key, base, col_count] = key.split('_');

    return {
        group,
        market_type,
        display_key,
        base,
        col_count,
    };
};